export default {"src":"/_next/static/media/ai-security.3a4adae0.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};